import { useMutateEntry } from '@utils/component-framework';

const useUpdateGeogebraEntryMutation = entryKey => {
  const updateComponentEntry = useMutateEntry(entryKey);
  return (entryBase64, result) => {
    updateComponentEntry(entry => {
      entry.data.base64 = entryBase64;
      entry.envelope.result = result;
      return entry;
    });
  };
};

export { useUpdateGeogebraEntryMutation };
//# sourceMappingURL=mutation.update-entry-value.js.map
